module.exports = __webpack_public_path__ + "static/media/github-wagyu-key-gen-screenshot.e2b1fa12.png";